export const SOCIAL_IMAGE_CONSTS = {
    socialAnnounceImageMsg: 'Картинка для соцсетей',
    socialImageTooltipMsg:
        'Отрегулируйте фото по вертикали с помощью перетаскивания'
}
